import request from "@/utils/interceptor.js";

//新增量表年龄分类
export function postFactorScaleAgeCategory(data) {
  return request({
    url: "/api/pas/factor-scale-age-category",
    method: "post",
    data,
  });
}
//量表年龄分类列表
export function getFactorScaleAgeCategory(params) {
  return request({
    url: "/api/pas/factor-scale-age-category",
    method: "get",
    params,
  });
}
//更新量表年龄分类
export function putFactorScaleAgeCategory(data) {
  return request({
    url: `/api/pas/factor-scale-age-category/${data.id}`,
    method: "put",
    data,
  });
}
//删除量表年龄分类
export function deleteFactorScaleAgeCategory(data) {
  return request({
    url: `/api/pas/factor-scale-age-category/${data.id}`,
    method: "delete",
  });
}
// 关联量表
export function postFactorScaleAgeCategoryScale(data) {
  return request({
    url: `/api/pas/factor-scale-age-category-scale`,
    method: "post",
    data,
  });
}
//获取关联量表列表
export function getFactorScaleAgeCategoryScale(params) {
  return request({
    url: `/api/pas/factor-scale-age-category-scale`,
    method: "get",
    params,
  });
}
//删除关联量表
export function deleteFactorScaleAgeCategoryScale(data) {
  return request({
    url: `/api/pas/factor-scale-age-category-scale/${data.id}`,
    method: "delete",
  });
}
//全部量表列表
export function getTesterappFactorscaleList() {
  return request({
    url: `/api/testerapp/factorscale/list`,
    method: "get",
  });
}